import React from 'react';
import { TextField, Box } from '@mui/material';
import { IconSearch } from '../assets/icons';
import { useCommonStyles } from '../styles/commonStyles';

const SearchBar = ({
    value,
    onChange,
    onSearch,
    onKeyDown,
    placeholder = 'Search...',
    label = 'Search'
}) => {
    const commonStyles = useCommonStyles();

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && onSearch) {
            onSearch();
        }
        if (onKeyDown) {
            onKeyDown(e);
        }
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <TextField
                required
                label={label}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onKeyDown={handleKeyDown}
                className={commonStyles.searchField}
            />
            {onSearch && (
                <Box className={commonStyles.searchButton} onClick={onSearch}>
                    <IconSearch color='#ffffff' />
                </Box>
            )}
        </Box>
    );
};

export default SearchBar;
